import React from 'react';
import type { Guardian } from '../api';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { getEntityAbilities } from '../utils/entityAbilities';
import { EntityDigitalCard } from './EntityDigitalCard';

type GuardianCardProps = {
  guardian: Guardian;
};

export const getGuardianImagePath = (guardianName: string) => `/Guardians/${encodeURIComponent(guardianName)}.jpg`;

export const GuardianCard: React.FC<GuardianCardProps> = ({ guardian }) => {
  const artwork = useMonsterTokenStyle();
  const abilities = getEntityAbilities('Guardian', guardian.name);
  if (artwork === 'Digital' && abilities) return <EntityDigitalCard key={guardian.name} kind="Guardian" name={guardian.name} abilities={abilities} />;
  return (
    <div className="herald-card">
      <img
        loading="lazy"
        src={getGuardianImagePath(guardian.name)}
        alt={`Guardian ${guardian.name}`}
      />
    </div>
  );
};
